import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';

import ProviderList from 'Components/Presentation/Providers/ProviderList';
import ProviderEditContainer from './Edit';

import AllProvidersQuery from 'GraphQueries/Providers/AllQuery';
import NewProviderMutation from 'GraphQueries/Providers/NewMutation';
import NewProviderSubscription from 'GraphQueries/Providers/NewSubscription';
import DeleteProviderMutation from 'GraphQueries/Providers/DeleteMutation';
import DeleteProviderSubscription from 'GraphQueries/Providers/DeleteSubscription';

class ProviderIndexContainer extends React.Component {
    
    static defaultProps = {
        providers: [],
        loading: false
    }

    state = { 
        provider: null,
        saving: false
    }

    componentDidMount() {
        const { subscribeToChanges } = this.props;
        subscribeToChanges();
    }

    navigateWithData = (uri, provider) => {
        const { history } = this.props;
        this.setState({ provider });
        history.push(uri);
    }

    saveProvider = async (provider) => {
        const { onAlert, onAdd } = this.props;
        this.setState({ saving: true });
        onAdd(provider).then(x => {
            this.setState({ saving: false });
            this.navigateWithData(`/data-tools/providers/${provider.id}/manage/settings`, provider);
            onAlert('success', `Successfully added provider: ${provider.id}`);
        }).catch(error => {
            if(error.graphQLErrors) {
                error.graphQLErrors.map(({ message }, i) => {
                    if (message.match(/not authorized/gi)) {
                        onAlert('error', 'You are not authorised to add providers, please see a System Admin');
                    }
                    else { onAlert('error', message); }
                });
            }
            this.setState({ saving: false });
        })
    }

    deleteProvider = async (provider) => {
        const { onAlert, onDelete } = this.props;
        this.setState({ saving: true });
        onDelete(provider.id).then(x => {
            this.setState({ saving: false });
            onAlert('success', `Successfully deleted provider: ${provider.id}`);
        }).catch(error => {
            if(error.graphQLErrors) {
                error.graphQLErrors.map(({ message }, i) => {
                    if (message.match(/not authorized/gi)) {
                        onAlert('error', 'You are not authorised to delete providers, please see a System Admin');
                    }
                    else { onAlert('error', message); }
                });
            }
            this.setState({ saving: false });
        })
    }

    render() {
        const { providers, loading } = this.props;
        const { provider, saving } = this.state;
        return (
            <React.Fragment>
                <Route path="/data-tools/providers" exact render={props => {
                    return (
                        <ProviderList {...props} loading={loading || saving} onEdit={this.navigateWithData} providers={providers}
                            onProviderAdded={this.saveProvider} onProviderRemoved={this.deleteProvider} />
                    )}
                } />
                <Route path="/data-tools/providers/list" render={props => {
                    return (
                        <ProviderList {...props} loading={loading || saving} onEdit={this.navigateWithData} providers={providers}
                            onProviderAdded={this.saveProvider} onProviderRemoved={this.deleteProvider} />
                    )}
                } />
                <Route path="/data-tools/providers/:id/manage" render={routeProps => {
                    return (
                        <ProviderEditContainer {...this.props} {...routeProps} provider={provider} />
                    )}
                } />
            </React.Fragment>
        );
    }
}

export default compose(
    graphql(AllProvidersQuery(), {
        props: ({ data: { listProviders, loading, subscribeToMore } }) => ({ 
            providers: listProviders && listProviders.items, 
            loading,
            subscribeToChanges: params => {
                subscribeToMore({
                    document: NewProviderSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onCreateProvider } } }) => ({
                        ...prev,
                        listProviders: { items: [onCreateProvider, ...prev.listProviders.items.filter(item => item.id !== onCreateProvider.id)], __typename: 'Provider' }
                    })
                });
                subscribeToMore({
                    document: DeleteProviderSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onDeleteProvider } } }) => ({
                        ...prev,
                        listProviders: { items: [...prev.listProviders.items.filter(item => item.id !== onDeleteProvider.id)], __typename: 'Provider' }
                    })
                });
            }
        })
    }),
    graphql(NewProviderMutation(), { props: ({ mutate }) => ({ onAdd: input => mutate({ variables: { input } }) }) }),
    graphql(DeleteProviderMutation(), { props: ({ mutate }) => ({ onDelete: id => mutate({ variables: { id } }) }) })
)(ProviderIndexContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Providers/Index.js